import { render, staticRenderFns } from "./quyu.vue?vue&type=template&id=4e0a8974&scoped=true"
import script from "./quyu.vue?vue&type=script&lang=js"
export * from "./quyu.vue?vue&type=script&lang=js"
import style0 from "./quyu.vue?vue&type=style&index=0&id=4e0a8974&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0a8974",
  null
  
)

export default component.exports